import { atom } from 'jotai';

/* 전화번호 */
export const phoneNumberAtom = atom<string>('');

/* 인증번호 발송 여부 */
export const isCodeSentAtom = atom<boolean>(false);

/* 인증 완료 여부 */
export const isVerifiedAtom = atom<boolean>(false);

/* 타이머 리셋 키 (값이 변경되면 타이머 초기화) */
export const timerResetKeyAtom = atom<number>(0);

/* 편집 모드 여부 (프로필 페이지에서 번호 변경 중인지) */
export const isEditingAtom = atom<boolean>(false);
